import { lazy } from 'react'

export const CurrentWeightV1 = lazy(() => import('./v1/CurrentWeightV1'))
export const CurrentWeightV2 = lazy(() => import('./v2/CurrentWeightV2'))
export const CurrentWeightV3 = lazy(() => import('./v3/CurrentWeightV3'))
export const CurrentWeightV4 = lazy(() => import('./v4/CurrentWeightV4'))
